import React, { useState } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';

import { PrimaryButton, SecondaryButton } from '../components/buttons/Buttons';
import { Row } from "../components/Flex";
import SelectField from '../components/SelectField';
import { Portal } from '../typings';
import { clonePackage } from "../package-api";
import { ApiContextType } from "../api-context";
import { toast } from "react-toastify";

interface Props {
    id: number;
    api: ApiContextType;
    portals: Portal[];
    open: boolean;
    onClose: () => void;
}

function CloneDialog({ open, onClose, portals, id, api }: Props) {
    const [portalId, setPortalId] = useState<number>();

    const onClone = () => {
        toast.success('Package cloning started');
        clonePackage(api, id, portalId!)
            .then(() => {
                toast.success('Package cloned successfully');
                setPortalId(undefined);
                onClose();
            })
            .catch(() => toast.error('Failed to clone package'))
    };

    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Clone this package to another portal
                    </DialogTitle>
                    <SelectField
                        label="Portal"
                        placeholder="Select portal"
                        value={portalId}
                        options={portals.map(item => ({ value: item.id, text: item.name }))}
                        setValue={setPortalId}
                    />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Clone" onClick={onClone} disabled={false} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default CloneDialog;
